import type { InsightCategory } from '@/api/types'

export const CATEGORY_LABELS: Record<InsightCategory, string> = {
  revenue: 'Revenue',
  conversion: 'Conversion',
  competition: 'Competition',
  customer: 'Customer',
  advertising: 'Advertising',
  payment: 'Payment',
  technical: 'Technical',
  market: 'Market',
}
